var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgCheckboxArrow(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M15.712 4.125v3.361H8.82A2.343 2.343 0 006.5 9.511l-.014.156-.004.158v13.313c0 1.184.892 2.175 2.025 2.32l.156.013.157.005h13.318a2.343 2.343 0 002.32-2.025l.013-.156.005-.157V16.16h3.357v6.982c0 2.972-2.291 5.434-5.24 5.677l-.222.014-.233.005H8.82c-2.971 0-5.433-2.295-5.676-5.244l-.014-.223-.005-.233V9.82a5.703 5.703 0 015.239-5.676l.222-.014.234-.005h6.892zm10.445 0c.8 0 1.478.561 1.647 1.37l.026.155.008.156v7.859H24.48l-.001-3.837-9.594 9.406L13.852 18l-1.02-1.23 9.275-9.289h-3.82l.013-1.127-.002-.548V4.125h7.859z"
  }));
}

export default SvgCheckboxArrow;